module.exports = __webpack_public_path__ + "static/media/pw-win-percent-active-icon.800315be.svg";